import React, { useState } from "react";

import { CSpinner } from "@coreui/react";
import { toastr } from "react-redux-toastr";
import {
  Button,
  Col,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  Row,
  FormText,
  FormGroup
} from "reactstrap";
import { Field, reduxForm } from "redux-form";

// import logo from '../assets/imgs/logo_original.png';
import logoAvaliacao from "../../assets/imgs/logo-avaliacao.png";
import logoLivros from "../../assets/imgs/logo-livros.png";
import logo from "../../assets/imgs/logo_original.png";
import URL from "../../config/api";
import axios from "../../config/axios";
import Loading from "../Loading";

const validate = values => {
  const errors = {};
  if (!values.username) {
    errors.username = "Favor preencher o campo Usuário.";
  }
  if (!values.password) {
    errors.password = "Favor preencher o campo Senha.";
  }

  return errors;
};

const renderField = ({
  input,
  label,
  type,
  icon,
  meta: { touched, error, warning }
}) => (
  <FormGroup className="mb-3">
    <InputGroup>
      <InputGroupAddon addonType="prepend">
        <InputGroupText>
          <i className={icon} style={{ width: 14 }}></i>
        </InputGroupText>
      </InputGroupAddon>
      <Input {...input} type={type} placeholder={label} />
      <br />
    </InputGroup>
    {touched && error && <FormText color="danger">{error}</FormText>}
  </FormGroup>
);

let LoginForm = props => {
  const { handleSubmit, loading, showLogo = true } = props;
  const [username, setUsername] = useState("");
  const [usernameC, setUsernameC] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [passwordC, setPasswordC] = useState("");

  const [loadingForgot, setLoadingForgot] = useState(false);
  const [usuario, setUsuario] = useState(true);

  const usuarioFunction = () => {
    setUsuario(!usuario);
  };

  const forgotPassword = () => {
    setLoadingForgot(true);
    if (username === "") {
      setLoadingForgot(false);
      toastr.error("Erro", "Favor preencher o campo usuário.");
    } else {
      let obj = {
        username
      };
      axios
        .post(`${URL.api}forgetMyPassword`, obj)
        .then(response => {
          if (response.data.success) {
            toastr.success("Sucesso", response.data.data);
          } else {
            toastr.error("Erro", response.data.status);
          }
          setLoadingForgot(false);
        })
        .catch(response => {
          setLoadingForgot(false);
        });
    }
  };

  const cadastrarUsuario = () => {
    setLoadingForgot(true);
    if (usernameC === "") {
      setLoadingForgot(false);
      toastr.error("Erro", "Favor preencher o campo nome.");
      if (email === "") {
        setLoadingForgot(false);
        toastr.error("Erro", "Favor preencher o campo email.");
      }
      if (phone === "") {
        setLoadingForgot(false);
        toastr.error("Erro", "Favor preencher o campo phone.");
      }
      if (passwordC === "") {
        setLoadingForgot(false);
        toastr.error("Erro", "Favor preencher o campo senha.");
      }
    } else {
      let body = {
        token: "605bbe07-fac7-4bb2-8ea7-aa29038c0ec1",
        username: email,
        password: passwordC,
        email,
        name: usernameC,
        phone,
        role: "P",
        classrooms: [
          {
            id: 832,
            name: "5\u00b0 ANO",
            period: "M",
            disciplines: [],
            region_name: "Cear\u00e1",
            region_id: "8",
            school_name: "ESCOLA CRECHE CASTELINHO VERMELHO",
            school_id: "399"
          }
        ]
      };
      axios
        .post(`${URL.api}temporaryLogin`, body)
        .then(response => {
          if (response.data.success) {
            toastr.success(
              "Sucesso",
              "Um link de ativação será enviado para seu Email!"
            );
          } else {
            toastr.error("Erro", response.data.status);
          }
          setLoadingForgot(false);
        })
        .catch(response => {
          setLoadingForgot(false);
        });
    }
  };

  let imgLogo = logo;

  if (
    ["ava.livros.homologa.educandus.net", "ava.livros.educandus.net"].includes(
      window.location.host.toLowerCase()
    )
  ) {
    imgLogo = logoLivros;
  } else if (
    [
      "ava.avaliacao.homologa.educandus.net",
      "ava.avaliacao.educandus.net"
    ].includes(window.location.host.toLowerCase())
  ) {
    imgLogo = logoAvaliacao;
  }

  return (
    <>
      {/* <div className="switchLog">
        <div>
          <Button
            className="user"
            color="primary"
            onClick={usuarioFunction}
            disabled={usuario}
          >
            Sou usuário
          </Button>
        </div>
        <div>
          <Button
            className="notUser"
            onClick={usuarioFunction}
            disabled={!usuario}
            color="primary"
          >
            Não sou usuário
          </Button>
        </div>
      </div> */}
      <form onSubmit={handleSubmit}>
        {showLogo && (
          <>
            <div className="tlc">
              <img
                src={imgLogo}
                alt="Logo da plataforma"
                style={{
                  maxWidth: "160px",
                  maxHeight: "120px",
                  objectFit: "contain"
                }}
              />
            </div>
            <br />
          </>
        )}
        {usuario ? (
          <>
            {/* <p className="text-muted">Sign In to your account</p> */}
            <Field
              component={renderField}
              icon="fa fa-user"
              type="text"
              label="Usuário"
              name="username"
              onChange={e => setUsername(e.target.value)}
            />
            <Field
              component={renderField}
              icon="fa fa-key"
              type="password"
              label="Senha"
              name="password"
            />
            {showLogo ? (
              <>
                {loadingForgot ? (
                  <Loading />
                ) : (
                  <Row>
                    <Col xs="6">
                      <Button
                        color="primary"
                        disabled={loading}
                        type="submit"
                        className="d-flex justify-content-center align-items-center"
                      >
                        <>
                          <span style={loading ? { opacity: 0 } : null}>
                            Entrar
                          </span>
                          {loading && (
                            <CSpinner
                              size="sm"
                              color="white"
                              style={{ position: "absolute" }}
                            />
                          )}
                        </>
                      </Button>
                    </Col>
                    <Col xs="6" className="text-right">
                      <Button
                        color="link"
                        className="px-0"
                        onClick={forgotPassword}
                      >
                        Esqueci minha senha?
                      </Button>
                      <Button
                        color="link"
                        className="px-0"
                        onClick={usuarioFunction}
                      >
                        Criar uma conta
                      </Button>
                    </Col>
                  </Row>
                )}
              </>
            ) : (
              <>
                <div className="text-right mb-3">
                  <Button color="link" className="px-0">
                    Esqueci minha senha?
                  </Button>
                </div>
                <Button
                  color="primary"
                  disabled={loading}
                  type="submit"
                  className="d-flex justify-content-center align-items-center btn-block p-2"
                >
                  <>
                    <span style={loading ? { opacity: 0 } : null}>Entrar</span>
                    {loading && (
                      <CSpinner
                        size="sm"
                        color="white"
                        style={{ position: "absolute" }}
                      />
                    )}
                  </>
                </Button>
              </>
            )}
          </>
        ) : (
          <>
            {/* <p className="text-muted">Sign In to your account</p> */}
            <Field
              component={renderField}
              icon="fa fa-user"
              type="text"
              label="Nome"
              name="usernameC"
              onChange={e => setUsernameC(e.target.value)}
            />
            <Field
              component={renderField}
              icon="fa fa-envelope-o"
              type="text"
              label="Email"
              name="emailC"
              onChange={e => setEmail(e.target.value)}
            />
            <Field
              component={renderField}
              icon="fa fa-phone"
              type="text"
              label="Telefone"
              name="phoneC"
              onChange={e => setPhone(e.target.value)}
            />
            <Field
              component={renderField}
              icon="fa fa-key"
              type="password"
              label="Senha"
              name="passwordC"
              onChange={e => setPasswordC(e.target.value)}
            />
            {showLogo ? (
              <>
                {loadingForgot ? (
                  <Loading />
                ) : (
                  <Row>
                    <Col xs="6">
                      <Button
                        color="primary"
                        disabled={loading}
                        onClick={cadastrarUsuario}
                        className="d-flex justify-content-center align-items-center"
                      >
                        <>
                          <span style={loading ? { opacity: 0 } : null}>
                            Cadastrar
                          </span>
                          {loading && (
                            <CSpinner
                              size="sm"
                              color="white"
                              style={{ position: "absolute" }}
                            />
                          )}
                        </>
                      </Button>
                    </Col>
                    <Col xs="6" className="text-right">
                      <Button
                        color="link"
                        className="px-0"
                        onClick={usuarioFunction}
                      >
                        Já tenho uma conta
                      </Button>
                    </Col>
                  </Row>
                )}
              </>
            ) : (
              <>
                <div className="text-right mb-3">
                  <Button color="link" className="px-0">
                    Esqueci minha senha?
                  </Button>
                </div>
                <Button
                  color="primary"
                  disabled={loading}
                  type="submit"
                  className="d-flex justify-content-center align-items-center btn-block p-2"
                >
                  <>
                    <span style={loading ? { opacity: 0 } : null}>Entrar</span>
                    {loading && (
                      <CSpinner
                        size="sm"
                        color="white"
                        style={{ position: "absolute" }}
                      />
                    )}
                  </>
                </Button>
              </>
            )}
          </>
        )}
      </form>
    </>
  );
};

export default reduxForm({
  form: "login",
  validate
})(LoginForm);
